<template>
    <CardPage :section="2" :page="13" nextLabel="Save" :nextDisabled="nextDisabled">
        <p>Fill in your information.</p>
        <v-sheet class="pa-3 mb-1" :elevation="1" v-for="(fact, index) in selectedFacts" :key="index">
            <v-layout row wrap align-center>
                <v-flex xs12 class="caption font-weight-bold input-label py-1 mb-1">{{ fact.question }}</v-flex>
                <v-flex xs12 v-if="fact.hasOwnProperty('value1')">
                    <v-text-field
                        outline
                        single-line
                        :type="fact.type1 || 'text'"
                        :label="fact.label1"
                        :value="fact.value1"
                        @input="input(fact, 'value1', $event)"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="fact.hasOwnProperty('value2')">
                    <v-text-field
                        outline
                        single-line
                        :type="fact.type2 || 'text'"
                        :label="fact.label2"
                        :value="fact.value2"
                        @input="input(fact, 'value2', $event)"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="fact.hasOwnProperty('value3')">
                    <v-text-field
                        outline
                        single-line
                        :type="fact.type3 || 'text'"
                        :label="fact.label3"
                        :value="fact.value3"
                        @input="input(fact, 'value3', $event)"
                    ></v-text-field>
                </v-flex>
                <v-flex class="font-italic input-label" xs12>{{ factText(fact.id, index) }}</v-flex>
            </v-layout>
        </v-sheet>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { each } from 'lodash';

export default {
    computed: {
        selectedFacts: get('section2/selectedFacts'),
        factText: get('section2/factText')
    },
    methods: {
        input(fact, prop, event) {
            this.$store.set(`section2/facts@${fact.id}.${prop}`, event);
        },
        nextDisabled() {
            let isDisabled = false;

            each(this.selectedFacts, fact => {
                if (fact.hasOwnProperty('value1') && !fact['value1']) {
                    isDisabled = true;
                }
                if (fact.hasOwnProperty('value2') && !fact['value2']) {
                    isDisabled = true;
                }
                if (fact.hasOwnProperty('value3') && !fact['value3']) {
                    isDisabled = true;
                }
            });

            return isDisabled;
        }
    }
};
</script>
